module.exports = __webpack_public_path__ + "images/檀程长图_06-5.jpg?v=3088091c";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_06-5.jpg
 ** module id = 195
 ** module chunks = 1 2
 **/